import { Injectable } from '@angular/core';

/**
 * Service to load application constants derived in constants.json
 */
@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
  // see http://stackoverflow.com/a/30112075/5997007
  /**
   * the constants map of application
   */
  private constants: Map<string, string | number>;

  /**
   * instantiates service with contents from static json
   * @param jsonHelperService - JsonHelperService
   */
  public constructor() {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const config = require('./constants.json');
    this.fillConfig(config);
  }

  /**
   * fills config from static json file
   * @param config - static json file content
   */
  private fillConfig(config: any): void {
    const convertJsonConfigToMap = (json: any): Map<string, any> => {
      const map = new Map<string, any>();
      for (const obj in json) {
        // eslint-disable-next-line no-prototype-builtins
        if (json.hasOwnProperty(obj)) {
          map.set(obj, json[obj]);
        }
      }
      return map;
    };

    this.setConstants(convertJsonConfigToMap(config));
  }

  /**
   * sets the constants map
   * @param map - key value map from static input
   */
  public setConstants(map: Map<string, any>): void {
    this.constants = map;
  }

  /**
   * gets a constant value from config
   * @param key - identifier of config value
   * @returns {string|Number} - constants' value
   */
  public get(key: string): any {
    const value = this.constants.get(key);
    if (value === undefined || value === null) {
      // eslint-disable-next-line no-console
      console.error(`the key '${key}' does not exist`);
    }
    return this.constants.get(key);
  }
}
